import React from 'react';
import LinkVoltar from '../../shared/link/Link-back';
import { useTheme } from '../../hooks/theme';

import './searchResult.scss';

const SearchResult = (props) => {
  delete props.canaisDoPlano.planName
  const theme = useTheme();
  const busca = props.busca;
  const canaisDoPlano = props.canaisDoPlano;
  const clearSearch = props.clearSearch;
  const imageDefault = 'https://www.claro.com.br/imagem/logo-generico-atual-claro-1509143658356.png';

  const result = () => {
    let contador = 0;

    const resultado = (
      <div className="mdn-Accordion result-search">
        <div className="mdn-Accordion-box is-expanded" aria-label="Acordion clicável para expandir o conteúdo">
          <button className="mdn-Accordion-toggle mdn-Text mdn-Text--body mdn-u-color--danger">
            Resultado da pesquisa
          </button>
          <div className="mdn-Accordion-content">
            {Object.keys(canaisDoPlano).map((key) => {
              return canaisDoPlano[key].map((value) => {
                if (value.nome.toLowerCase().includes(busca)) {
                  contador++;
                  return (
                    <div key={value.nome} className={`canal ${theme === 'contrast' ? 'contrast' : ''} `}>
                      <div className="imagem">
                        <img
                          src={value.imagem ? `https://mondrian.claro.com.br/${value.imagem}`.trim().toLowerCase() : imageDefault}
                          alt={value.imagem.toLowerCase()}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = imageDefault;
                          }}
                        />
                      </div>
                      <div className="nome mdn-Text mdn-Text--body">
                        <div>{key}</div>
                      </div>
                      <div className="categoria mdn-Text mdn-Text--body">
                        <div>{value.nome}</div>
                      </div>
                    </div>
                  );
                } else {
                  return false;
                }
              });
            })}
          </div>
        </div>
      </div>
    );

    if (contador > 0) {
      return resultado;
    } else {
      return (
        <div className="mdn-Text mdn-Text--body canal-nao-encontrado">
          O canal <b>{busca}</b> não foi encontrado neste plano.
        </div>
      );
    }
  };

  return (
    <React.Fragment>
      {result()}
      <LinkVoltar clearSearch={clearSearch} />
    </React.Fragment>
  );
};

export default SearchResult;
